import React, { useState, useCallback, useMemo } from 'react';
import api from 'services';

const RelatoriosSafras = React.createContext({});

export function RelatoriosSafrasProvider({ children }) {
  const [custosSafras, setCustosSafras] = useState([]);
  const [custosSafrasLoading, setCustosSafrasLoading] = useState(false);

  const [custosSafrasById, setCustosSafrasById] = useState([]);
  const [custosSafrasByIdLoading, setCustosSafrasByIdLoading] = useState(false);

  const [colhidoSafras, setColhidoSafras] = useState([]);
  const [colhidoSafrasLoading, setColhidoSafrasLoading] = useState(false);

  const [colhidoSafrasById, setColhidoSafrasById] = useState([]);
  const [colhidoSafrasByIdLoading, setColhidoSafrasByIdLoading] =
    useState(false);

  const [atividadesTalhoesSafra, setAtividadesTalhoesSafra] = useState([]);
  const [atividadesTalhoesSafraLoading, setAtividadesTalhoesSafraLoading] =
    useState(false);

  const [relAtividades, setRelAtividades] = useState({ content: [] });
  const [relAtividadesLoading, setRelAtividadesLoading] = useState(false);

  const [relAtividadesResumo, setRelAtividadesResumo] = useState({
    content: [],
    total: [],
  });

  const [relAtividadesResumoLoading, setRelAtividadesResumoLoading] =
    useState(false);

  const [relInsumosPorAtividade, setRelInsumosPorAtividade] = useState({
    content: [],
    resumo: [],
  });
  const [relInsumosPorAtividadeLoading, setRelInsumosPorAtividadeLoading] =
    useState(false);

  const getCustosTalhoesSafra = useCallback(async (filter) => {
    try {
      setCustosSafrasLoading(true);
      const response = await api
        .relatoriosSafras()
        .getCustosTalhoesSafra(filter);
      setCustosSafras(response);
      setCustosSafrasLoading(false);
    } catch {
      setCustosSafrasLoading(false);
    }
  }, []);

  const getCustosTalhoesSafraById = useCallback(async (id, filter) => {
    try {
      setCustosSafrasByIdLoading(true);
      const response = await api
        .relatoriosSafras()
        .getCustosTalhoesSafraById(id, filter);
      setCustosSafrasById(response);
      setCustosSafrasByIdLoading(false);
    } catch {
      setCustosSafrasByIdLoading(false);
    }
  }, []);

  const getColhidoTalhoesSafra = useCallback(async (filter) => {
    try {
      setColhidoSafrasLoading(true);
      const response = await api
        .relatoriosSafras()
        .getColhidoTalhoesSafra(filter);
      setColhidoSafras(response);
      setColhidoSafrasLoading(false);
    } catch {
      setColhidoSafrasLoading(false);
    }
  }, []);

  const getColhidoTalhoesSafraById = useCallback(async (id, filter) => {
    try {
      setColhidoSafrasByIdLoading(true);
      const response = await api
        .relatoriosSafras()
        .getColhidoTalhoesSafraById(id, filter);
      setColhidoSafrasById(response);
      setColhidoSafrasByIdLoading(false);
    } catch {
      setColhidoSafrasByIdLoading(false);
    }
  }, []);

  const getAtividadesTalhoesSafra = useCallback(async (id, filter) => {
    try {
      setAtividadesTalhoesSafraLoading(true);
      const response = await api
        .relatoriosSafras()
        .getAtividadesTalhoesSafra(id, filter);
      setAtividadesTalhoesSafra(response);
      setAtividadesTalhoesSafraLoading(false);
    } catch {
      setAtividadesTalhoesSafraLoading(false);
    }
  }, []);

  const getRelAtividades = useCallback(async (filter) => {
    try {
      const formatedFilters = {
        ...filter,
        fazendas: filter?.fazendas.map((item) => Number(item?.id)),
      };

      delete formatedFilters.fazenda;

      setRelAtividadesLoading(true);
      const response = await api
        .relatoriosSafras()
        .getRelAtividades(formatedFilters);
      setRelAtividades(response);
    } catch {
    } finally {
      setRelAtividadesLoading(false);
    }
  }, []);

  const getRelAtividadesResumo = useCallback(async (filter) => {
    try {
      const formatedFilters = {
        ...filter,
        fazendas:
          (filter?.fazenda ?? []).length > 0
            ? filter?.fazenda.map((item) => Number(item?.id))
            : [],
      };

      if (formatedFilters.fazenda) delete formatedFilters.fazenda;

      setRelAtividadesResumoLoading(true);
      const response = await api
        .relatoriosSafras()
        .getRelAtividadesResumo(formatedFilters);
      setRelAtividadesResumo(response);
    } catch {
    } finally {
      setRelAtividadesResumoLoading(false);
    }
  }, []);

  const getRelInsumosPorAtividade = useCallback(async (filter) => {
    try {
      const formatedFilters = {
        ...filter,
        fazendas:
          (filter?.fazenda ?? []).length > 0
            ? filter?.fazenda.map((item) => Number(item?.id))
            : [],
      };

      if (formatedFilters.fazenda) delete formatedFilters.fazenda;

      setRelInsumosPorAtividadeLoading(true);
      const response = await api
        .relInsumos()
        .getRelInsumosPorAtividade(formatedFilters);
      setRelInsumosPorAtividade(response);
    } catch {
    } finally {
      setRelInsumosPorAtividadeLoading(false);
    }
  }, []);

  const value = useMemo(
    () => ({
      getCustosTalhoesSafra,
      custosSafras,
      custosSafrasLoading,
      getCustosTalhoesSafraById,
      custosSafrasById,
      custosSafrasByIdLoading,
      getColhidoTalhoesSafra,
      colhidoSafras,
      colhidoSafrasLoading,
      getColhidoTalhoesSafraById,
      colhidoSafrasById,
      colhidoSafrasByIdLoading,
      getAtividadesTalhoesSafra,
      atividadesTalhoesSafra,
      atividadesTalhoesSafraLoading,
      getRelAtividades,
      setRelAtividades,
      relAtividades,
      relAtividadesLoading,
      getRelAtividadesResumo,
      relAtividadesResumo,
      relAtividadesResumoLoading,
      getRelInsumosPorAtividade,
      relInsumosPorAtividade,
      relInsumosPorAtividadeLoading,
    }),
    [
      getCustosTalhoesSafra,
      custosSafras,
      custosSafrasLoading,
      getCustosTalhoesSafraById,
      custosSafrasById,
      custosSafrasByIdLoading,
      getColhidoTalhoesSafra,
      colhidoSafras,
      colhidoSafrasLoading,
      getColhidoTalhoesSafraById,
      colhidoSafrasById,
      colhidoSafrasByIdLoading,
      getAtividadesTalhoesSafra,
      atividadesTalhoesSafra,
      atividadesTalhoesSafraLoading,
      getRelAtividades,
      setRelAtividades,
      relAtividades,
      relAtividadesLoading,
      getRelAtividadesResumo,
      relAtividadesResumo,
      relAtividadesResumoLoading,
      getRelInsumosPorAtividade,
      relInsumosPorAtividade,
      relInsumosPorAtividadeLoading,
    ],
  );

  return (
    <RelatoriosSafras.Provider value={value}>
      {children}
    </RelatoriosSafras.Provider>
  );
}

export function useRelatoriosSafras() {
  const context = React.useContext(RelatoriosSafras);

  if (!context)
    throw new Error(
      'useRelatoriosSafras must be used within a RelatoriosSafrasProvider',
    );

  return context;
}
